import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0
};
import Progress from "@/modules/vue/components/Progress.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerForm',
  props: {
    player: null,
    type: null
  },
  setup(__props) {
    const props = __props;
    const rate = computed(() => Math.ceil(props.player.form / 33.5));
    const classes = computed(() => {
      return {
        3: 'rotate-270 text-green-500',
        2: 'text-gray-400',
        1: 'rotate-90 text-red-500'
      }[rate.value];
    });
    const color = computed(() => {
      return {
        3: ColorEnum.Green,
        2: ColorEnum.Yellow,
        1: ColorEnum.Red
      }[rate.value];
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return __props.type === 'progress' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Progress, {
        value: 100,
        color: _unref(color)
      }, null, 8, ["color"])])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["flex items-center justify-center", _unref(classes)])
      }, [_createVNode(_component_Icon, {
        icon: _ctx.IconEnum.CaretSquareRightRegular,
        size: "1rem"
      }, null, 8, ["icon"])], 2));
    };
  }
});